import React from 'react';
import styled from 'styled-components';

const LogoContainer = styled.div<{ size?: number }>`
  display: inline-block;
  width: ${props => props.size || 300}px;
  height: auto;
`;

const LogoSvg = styled.svg`
  width: 100%;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
`;

interface EventosHubLogoProps {
  size?: number;
}

export const EventosHubLogo: React.FC<EventosHubLogoProps> = ({ size = 300 }) => {
  return (
    <LogoContainer size={size}>
      <LogoSvg xmlns="http://www.w3.org/2000/svg" viewBox="70 37 490 139">
        <defs>
          <linearGradient id="p" x1="0" x2="1">
            <stop offset="0" stopColor="#6B7BFF"/>
            <stop offset="1" stopColor="#3B3FE0"/>
          </linearGradient>
          <style>
            {`.big{font-family:Inter, sans-serif; font-weight:800; fill:#fff}
             .small{font-family:Inter, sans-serif; font-weight:600; fill:#fff}`}
          </style>
        </defs>
        <rect width="100%" height="100%" fill="transparent"/>
        {/* Monogram circle */}
        <g transform="translate(36,18)">
          <circle cx="100" cy="84" r="64" fill="url(#p)"/>
          <text x="72" y="100" font-family="Inter, sans-serif" font-weight="800" font-size="36" fill="#fff">EH</text>
          <rect x="72" y="150" width="56" height="6" rx="3" fill="#2f33a1" opacity="0.6"/>
        </g>
        {/* Wordmark */}
        <text x="240" y="110" className="big" font-size="44">EventosHub</text>
        <text x="240" y="145" className="small" font-size="16">Gestiona votaciones, trofeos y resultados</text>
      </LogoSvg>
    </LogoContainer>
  );
};